import styled from "styled-components"
import bg13 from '@/img/activity22/13.png'
import dark from '@/img/activity22/dark.png'
import Icon0 from '@/img/activity22/0.png'
import Bg65 from '@/img/activity22/65.png'
import Title from '@/img/activity22/title.png'
import Bg47 from '@/img/activity22/47.png'
import Star1 from '@/img/activity22/star1@2x.png'
import Star2 from '@/img/activity22/star2@2x.png'
import huangguan from '@/img/activity22/huangguan.png'
import huangguan1 from '@/img/activity22/huangguan(1).png'
import huangguan2 from '@/img/activity22/huangguan(2).png'
import close from '@/img/activity22/close.png'
import reward from '@/img/activity22/reward38.png'
import tabBg from '@/img/activity22/bg_tab.png'
import tabBg1 from '@/img/activity22/bg_tab1.png'
import firends from '@/img/activity22/firends.png'
import bgd1 from '@/img/activity50/bgd1@2x.png'
import bgd1Empty from '@/img/activity50/bgd1Empty@2x.png'
import title_bgd from '@/img/activity50/title_bgd@2x.png'
import todeal from '@/img/activity50/todeal@2x.png'
import todeal2 from '@/img/activity50/todeal2@2x.png'



export const Ctitle = styled.div`
  position: absolute;
  top: -41px;
  left: -1px;
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  z-index: 100;
  background-image: url(${Title});
  background-repeat: no-repeat;
  background-size: 100% 85px;
  >div{
    width: calc(50% - 20px);
    line-height: 44px;
    text-align: center;
    font-size: 19px;
    font-family: Alibaba PuHuiTi;
    font-weight: 800;
    color: #8F4000;
  }

`

export  const RewardContent = styled.div`
  // background-color: #ffefe6; 
  padding:0 10px;
  border-radius: 8px;
  position: relative;
  background-image: url(${Bg65});
  background-repeat: no-repeat;
  background-size: 100%;
  z-index: 200;
  max-height: 80vh;
  overflow: scroll;
  padding-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3B3B3B;
    line-height: 47px;
    position: relative;
    padding-left: 16px;
    &::before {
      content: '';
      position: absolute;
      width: 8px;
      height: 28px;
      left: 0px;
      top: 50%;
      border-radius: 4px;
      transform: translateY(-50%);
      background: linear-gradient(180deg, #F1D67F, #EEAC4A);
      display: inline-block;
    }
  }
  .title2 {
    font-size: 14px;
    font-weight: 400;
    color: #3B3B3B;
    line-height: 27px;
  }
`
export  const RewardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  
`
export  const RewardItem = styled.div`
  
  .item_header{
    width:100%;
    background-image: url(${bg13});
    background-size: 100% 100%;
    height: 10.667vw;
    text-align: left;
    padding: 10px  0 0 11px;
    box-sizing: border-box;
    color: #8F4000;
    border-radius: 4px 4px 0 0;
    min-height: 48px;
  }
  .item_header_title {
   
    font-size: 12px;
  }
  .item_header_title_tips {
    font-size: 10px;
    font-weight: 400;
  }
  .item_body{
    background: #FFFFFF;
    border-radius:0px 0px 8px 8px;
    height: 79px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 10px;
    color: #888;
    .empty-img{
      width: 53px;
      margin: auto;
    }
    .li {
      padding-left: 20px;
      line-height: 18px;
      position: relative;
      &::before{
        position: absolute;
        content:'';
        width: 4px;
        height:4px;
        display:inline-block;
        left: 10px;
        top: 7px;
        background-color: #FF3630;
        border-radius: 50%;
        
        // font-size: 20px;
      }
    }
  }
`
export const Content = styled.div`

  // .un-desc-modal {
  //   width: 84vw;
  //   .am-modal-header {
  //     padding-left: 0;
  //     padding-right: 0;
  //   }
  //   .am-modal-content {
  //     border-radius: 0;
  //     padding-top: 10px;
  //     background-color: transparent;
  //     overflow: visible;
  //     .am-modal-body {
  //       padding: 0;
  //       background-color: #fff;
  //       border-radius: 8px;
  //     
  //       background-repeat: no-repeat;
  //       background-size: 316px auto;
  //       background-position: bottom right;
  //       padding: 38px 26px 45px;
  //     }
  //   }
  // }
`

export const TimeTick = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, .6)
  border-radius: 3px;
  margin: 0 12px;
  background-image: url(${dark});
  background-size: 100% 100%;
  height: 30px;
  margin: 10px;
  // transform: translateY(5vw);
  color: white;
  .title {
    height: 18px;
    line-height: 18px;
    padding: 0px 10px 0px 16px;
    border-right: 1px solid white;
  }
  .content {
    flex:1;
    text-align:center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    
  }
`

export  const DescIcon = styled.div`

    width: 38px;
    height: 48px;
    z-index:2;
    text-align:right;
    background-image: url(${Icon0});
    background-size: 38px 38px;
    background-position: right center;
    background-repeat: no-repeat;
    position: absolute;
    top: 168px;
    right: 0;
    color: white;
    font-size:12px;
    display:flex;
    align-items: center;
    padding: 0 5px ;
    justify-content: flex-end;
  
`
export  const InviteBox = styled.div`
  .title-box{
    text-align: center;
  }
  .message {
    text-align:center;
    margin-top: -12px;
    padding-top: 5px;
    letter-spacing: 4px;
    padding-bottom: 7px;
    font-size: 10px;
    font-weight: 300;
    color: rgba(255,208,218);
  }
  .title {
    text-align: center;
    color: white;
    font-size: 20px;
    line-height: 58px;
    position: relative;
    display: inline-block;
    &::before,  &::after{
      content: '';
      display: block;
      width: 20px;
      height:14px;
      position: absolute;
      top: 50%;
      margin-top: -10px;
      // background: white;
      background-size: 100%;
    } 
    &::before{
      left: -30px;
      background-image: url(${Star2});
      
    }
    &::after{
      right: -30px;
      background-image: url(${Star1});
    }
  }
  .table {
    &+.table {
      margin-top: 10px;
    }
    margin: 0 15px;
    border-radius: 4px;
    padding: 15px 0 45px 15px;
    background-image: url(${Bg65});
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    .list_box{
      
      padding-right: 15px;
      max-height: 90vw;
      overflow: scroll;

   
    }
  }
  .table_header {
    line-height: 20px;
    margin-right: 15px;
    overflow:hidden;
    padding-bottom: 10px;
    border-bottom: 1px solid #E8E1DF;
  }
  >img{
    width:calc(100% - 24px);
    margin: 0px 12px;
  }
  
  .table_item {
    color: #8A8685;
    line-height: 30px;
    display:flex;
    justify-content: space-between;
    .friends {
      width: 100px;
      padding-right:8px;
      flex-grow:2
    }
    // .name {
    //   width: 60px;
    //   padding-right: 8px;
    //   flex-grow:1
    // }
    
    .friends, .name  {
      white-space: nowrap;
      overflow: hidden; 
      text-overflow: ellipsis;
      flex-shrink: 0;
    }
    .week , .quarter {
      width: 120px;

      flex-grow:1;
      flex-shrink: 0;
    }
    .quarter { 
      text-align: center;
    }
    .week {
      width: 100px;
      padding-right:8px;
      text-align: center;
    }
    .no_state {
      width: 170px;
      min-width: 200px;
      padding-right: 8px;
      flex-grow:1
    }
   
  }
  .tips {
    color: #E0B6A4;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    position: absolute;
    bottom: 5px;
    left:0px;
    width: 100%;
    
  }
  .empty {
    width: 145px;
    display: block;
    margin:80px auto;
  }
  .reward_box {
    margin:0 15px;
    .item {
      border-radius: 8px;
      overflow: hidden;
    }
    .item_header  {
      height: 16.667vw;
      background-image: url(${reward});
      
      over-flow: hidden;
      .item_header_title {
        font-size: 13px;
        font-weight: 500;
      }
      .item_header_title_tips {
        line-height: 1.5;
      }
      
    }
  }
`
export  const DescContent = styled.div`
  position: relative;
  z-index: 200;
  // background-color: #ffefe6; 
  background-image: url(${Bg65});
    background-repeat: no-repeat;
    background-size: 100%;
  border-radius: 8px;
  padding: 25px 0px;
  .content {
    padding: 0px 18px;
    max-height: 70vh;
    overflow: scroll;
  }
  h1{
    margin: 10px 0 0 0;
    font-size: 16px;
    color: #3B3B3B;
    font-weight: 800;

  }
  h2 {
    margin: 5px 0 0 0;
    font-size: 14px;
    color: #3B3B3B;
    font-weight: 500;
    line-height: 1.8;
  }
  div {
    font-size: 12px;
    color: #292929;
    font-weight: 400;
    line-height: 1.8;
  }
  img {
    display: block;
    margin:5px auto;
    width: 250px;
    max-width: 100%;
    border-radius: 5px;
  }
  .tips {
    text-align: center;
    font-size: 12px;
  }
`

export  const Rank = styled.div`
  padding: 20px 15px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  .rank_table{
    position: relative;
    z-index:10;
    &::before {
      border-radius: 0 0 10px 10px;
      content: '';
      background: #fff;
      position: absolute;
      width:100%;
      height: 100%;
      left:0px;
      top: 0px;
      z-index: -1;
      // background-image: url(${tabBg1});
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    &.active::before  {
      transform: rotateY(180deg);
    }
  }
  .list_box {
    position: relative;
    // max-height: 300px;
    // overflow: scroll;
    padding-bottom: 8px;
    &.show{
      padding-bottom: 64px;
    }
  }
  .weeklist_box{
    border: 1px solid #E9E5E1;
    color: #9D9E9B;
    position: absolute;
    display: none;
    left: 30px;
    top: 40px;
    z-index: 14;
    padding:8px 0;
    border-radius: 4px;
    background: #FFFFFD;
 
    &.active {
      display: block;
    }
    >div{
      line-height: 30px;
      padding:0 15px;
    }
    .active{
      background:#F5F1F0;
    }
  }
  .tab_rank_item_header{
    color: #A39F99;
    .tab_rank_item{
      padding: 6px 0 4px;
      border-bottom: 1px solid #EEE6E2;
    }
 
  }
  
  .tab_rank_item_header, .list_box{
    padding-left: 17px;
    padding-right: 17px;
  }
  .list_box{
    min-height: 180px;
    padding-top: 7px;
    .bgd {
      position: relative;
      background-color: #FFC600;
      height: 26px;
      line-height: 26px;
      padding-left: 19px;
      margin:0 -16px;
      :before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 5px;
        height: 100%;
        background-color: #FFC600;
        z-index:10;
        transform: translatex(-4px);
      }
      :after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 5px;
        height: 100%;
        background-color: #FFC600;
        z-index:10;
        transform: translatex(4px);
       
      }
    }
    .empty{
      padding:40px 0;
      text-align: center;
      img {
        width: 183px;
        height: auto;
      }
    }
  }
  .tab{
   
    display: flex;
    position: relative;
    z-index: 10;
    &::before {
      content: '';
      position: absolute;
      width:100%;
      height: 100%;
      left:0px;
      bottom: -1px;
      z-index: -1;
      background-image: url(${tabBg});
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    &.active::before  {
      transform: rotateY(180deg);
    }
  }
 
  .tab_item {
    text-align: center;
    width: 200px;
    flex:1;
    line-height:44px;
    font-weight: 900;
    font-size: 16px;
    color: white;
    &.active {
      color: #2A2827;
    }
    .tab_item_img {
      width: 8px;
      height: 14px;
      margin-left: 15px;
      transition: all 0.3s;
      transform: rotate(-90deg);
      &.active {
        transform: rotate(90deg);
      }
    }

  }
  .tab_rank_item {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    // padding: 0 10px;
    >div{
      flex-shrink: 0;
    }
    .rank{
      flex-grow: 0;
      width: 30px;
      color: #333;
      text-align: center;
      background-size: 25px 20px;
      background-position: center center;
      background-repeat: no-repeat;
      &.rank0 {
        background-image: url(${huangguan})
      }
      &.rank1 {
        background-image: url(${huangguan1})
      }
      &.rank2 {
        background-image: url(${huangguan2})
      }
    }
    .person{
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 15px;
      flex-grow: 1;
      width: 120px;
      color: #333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      position: relative;
      &.tag{
          padding-right: 15px;
          // &::after{
          //   display: inline-block;
          //   content:"";
          //   position: absolute;
          //   top:50%;
          //   transform: translateY(-50%);
          //   z-index:10;
          //   right:0px;
          //   height: 15px;
          //   width: 32px;
          //   background-image: url(${firends});
          //   background-repeat: no-repeat;
          //   background-position: right center;
          //   background-size: 32px 15px;
          // }
          // &::after{
          //   display: block;
          //   content:"";
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 100%;
          //   height: 100%;
          //   background: #eee;
          //   &::after{ 
          //     display: block;
          //     content:"";
          //     position: absolute;
          //     top:50%;
          //     right:0px;
          //     transform: translateY(-50%);
          //     z-index:10;
          //     height: 15px;
          //     width: 32px;
          //     background-color: red;
              // background-image: url(${firends});
              // background-repeat: no-repeat;
              // background-position: right center;
              // background-size: 32px 15px;
            // }
          }
        }
    }
    .person {
      display: flex;
      align-items: center;
      span{
        flex-shrink: 1;
        display: inline-block;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
      }
      img {
        flex: 1;
        flex-shrink: 0;
        max-width:32px;
        height:15px;
      }
    }
    .name{
      width: 80px;
      flex-grow: 1;
      color: #807979;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .changePct{
      text-align:right;
      width: 60px;
      flex-grow: 0;
      &.green {
        color: #4ACA9A;
      }
      &.active{
        color: #E4384B;
      }
    }

  }
 
  .bar{
    color: white;
  }
  .bottom {
    width: 100%;
    height: 64px;
    position: absolute;
    bottom: 0px;
    left:0 px;
    background-image: url(${Bg47});
    background-size: 100% 100%;
    color: white;

    box-sizing: border-box;
    .week {
      padding:0 15px;
      font-size: 15px;
      line-height: 32px;
    }
    .flexbottom {
      line-height: 32px;
      display: flex;
      padding-left: 15px;
      justify-content: space-between;
      >div:first-child{
        text-overflow: ellipsis;
        overflow: hidden; 
        white-space: nowrap; 
      }
      >div:last-child{
        // padding:0 15px;
        min-width: 180px;

      }
    }
  }
  .message{
    padding-top: 10px;
    color: #E0B6A4;
    line-height: 18px;
    text-align:center;
    font-size:12px;
  }
  .title_box {
    .rank {
      padding-top: 10px;
      padding-left: 26px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #131313;
      line-height: 27px;
      background-image: url(${title_bgd});
      background-size: 5px 15px;
      background-repeat: no-repeat;
      background-position: 15px 15px;
    }
    .combineName {
      line-height: 32px;
      display: flex;
      padding-left: 15px;
      padding-bottom: 5px;
      font-size: 12px;
      color: #131313;
      justify-content: space-between;
      font-weight: bold;
      >div:first-child{
        text-overflow: ellipsis;
        overflow: hidden; 
        white-space: nowrap; 
      }
      >div:last-child{
        // padding:0 15px;
        min-width: 180px;

      }
    }
   
  }
  .empty {
    width: 
  }
`
export  const IconClose = styled.div`

  width: 40px;
  height:40px;
  position: absolute;
  z-index: 300;
  top: -40px;
  right: 0px;
  background-image: url(${close});
  background-size: 25px 25px;
  background-repeat: no-repeat;
  background-position: center center;

`
export  const Combination = styled.div`
  width: 94vw;
  margin:auto;
  height: 48.8vw;
  background-image: url(${bgd1});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  .title {
    display:flex;
    justify-content: start;
    font-size: 4vw;
    padding-left: 2.4vw;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    color: #A0211D;
    line-height: 12.8vw;
    
    // div:first-child{
    //   color: #A0211D;
    // }
  }
  .container {
    margin-top: 2.3vw;
    display:flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 4.4vw;
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      line-height: 6.1vw;
      color: #A0211D;
    }
    .li {
      padding-left: 2.4vw;
      font-size: 4vw;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      line-height: 6.1vw;
      span:first-child {
        color: #9F211D;
      }
    }
    .btn {
      width:40.5vw;
      height: 14.13vw;
      background-image: url(${todeal});
      background-size: 100% 100%;
      margin: 0;
      margin-right: 25px;
    }
  }
  &.empty {
    background-image: url(${bgd1Empty});
    position: relative;
    .title {
      font-size: 4.67vw;
      width: 100%;
      text-align: center;
      justify-content: center;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 48px;
    }
    .btn2 {
      margin: auto;
      width: 151px;
      height: 52px;
      background-image: url(${todeal2});
      background-size: 100% 100%;
      margin: auto;
      position: absolute;
      left: 0;
      right: 0;
      z-index:10;
      bottom: 41px;
    }
  }
`
export  const CombinationPopup = styled.div`
  border-radius: 10px 10px 0 0;
  text-align: left;
  padding: 25px;
  .modalTitle {
    text-align: center;
    font-weight: 400;
    color: #313131;
    line-height: 1;
    font-size: 16px;
  }
  .closeImg {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 40px;
    height:40px;
    position: absolute;
    z-index: 10;
    background-image: url(${close});
    background-size: 25px 25px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .state {
    width: 20px;
    height: 20px;
    margin-right: 9px;
    font-size:0;
    vertical-align: middle;
    user-select: none;
  }
  .content {
     margin-top: 20px;
     .li {
        display: inline-block;

        width: 50%;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #313131;
        margin-bottom: 20px;
        &.active {
         
        }
        &.empty {
          color:#FF6502;
        }
     }
    
  }

  .emptyList{
    margin-top: 60px;
    margin-bottom:53px;
    text-align: center;
    .empty {
      margin-top: 13px;
    }
   
  }
  .competition {
    margin:auto;
    width: 225px;
    height: 45px;
    background: linear-gradient(-88deg, #FF6500 0%, #FFAF00 99%);
    border-radius: 45px;
    text-align: center;
    line-height: 45px;
    font-size: 20px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    &.disabled {
      background: #858585;
      color: #FFFFFF;
    }
  }
  .toCombination {
    margin-top: 6px;
    text-align: center;
    font-size: 15px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #FF6400;
    line-height: 33px;
    img {
      margin-left: 3px;
      height: 12px;
    }
  }
  .tips {
    margin-top: 17px;
  }
`




// WEBPACK FOOTER //
// ./src/views/activity_50/components/style.js